import React, { PureComponent as Component } from 'react'

export default (WrappedComponent, tappableProps) => {
  return class Interactable extends Component {
    static propTypes = {
      style: React.PropTypes.object,
      onTap: React.PropTypes.func,
      onPress: React.PropTypes.func,
      onHover: React.PropTypes.func
    }

    static defaultProps = {
      onHover: () => {},
      onPress: () => {},
      onTap: () => {}
    }

    constructor (props) {
      super(props)

      this.state = {
        isHovering: false,
        isPressing: false,
        isTapping: false,
        isMouseDown: false
      }
    }

    handleMouseOver = (e) => {
      this.props.onHover(e)
      this.setState({ isHovering: true })
    }

    handleMouseLeave = (e) => {
      this.setState({
        isHovering: false,
        isPressing: false,
        isTapping: false,
        isMouseDown: false
      })
    }

    handleMouseUp = (e) => {
      this.setState({ isMouseDown: false })
    }

    handleMouseDown = (e) => {
      this.setState({ isMouseDown: true })
    }

    handleMouseOut = (e) => {}

    render () {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onMouseOver={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
          onMouseUp={this.handleMouseUp}
          onMouseDown={this.handleMouseDown}
          onMouseOut={this.handleMouseOut}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/utility/Interactable.js